'use client'

import {useCallback} from 'react'
import {useHistory, useLocation} from 'react-router-dom'

export const useQueryState = (name: string) => {
  const location = useLocation()
  const history = useHistory()

  const changeHandler = useCallback(
    (value: string | null) => {
      const searchParams = new URLSearchParams(history.location.search)

      if (value) {
        searchParams.set(name, value)
      } else {
        searchParams.delete(name)
      }

      history.replace({search: searchParams.toString()})
    },
    [history, name],
  )

  return [new URLSearchParams(location.search).get(name) || undefined, changeHandler] as const
}
